import { FormEvent } from "react"
import { DeliveryAddressForm, ItemAddressWhisper } from "types/address"

export default function DeliveryAddress(props: {
  onDataChange: (data: DeliveryAddressForm) => void
  shownData: DeliveryAddressForm

  onWhisperSelected: (address: ItemAddressWhisper) => void
  whisperAddress: ItemAddressWhisper[]
  showWhisper: boolean

  showForm: boolean
}) {
  const handleFormChange = (e: FormEvent<HTMLFormElement>) => {
    props.onDataChange({
      company: e.currentTarget.company.value,
      address: e.currentTarget.address.value,
      phone: e.currentTarget.phone.value,
      email: e.currentTarget.email.value,
    })
  }

  const handleInputChange = (e: FormEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget
    props.onDataChange({
      ...props.shownData,
      [name]: value,
    })
  }

  return (
    <div
      className={`flex flex-col items-center justify-center mb-5 max-w-[20rem] h-full w-full ${
        props.showForm ? "" : "hidden"
      }`}
    >
      <h2 className="pb-5 text-xl font-semibold underline">Dodací adresa</h2>
      <div className="flex flex-col w-full h-full">
        <form className="grid flex-col w-full h-full grid-cols-2 border-[#e5e7eb] gap-3 text-center">
          <input
            type="text"
            name="company"
            placeholder="Společnost"
            className="w-full col-span-2 p-2 border rounded-lg"
            required
            value={props.shownData.company}
            onChange={(e) => handleInputChange(e)}
          />

          <div className="relative w-full col-span-2">
            <input
              type="text"
              name="address"
              placeholder="Adresa"
              className={`w-full p-2 border rounded-t-lg ${
                props.showWhisper && props.whisperAddress.length > 0
                  ? ""
                  : "rounded-b-lg"
              }`}
              value={props.shownData.address}
              required
              onChange={(e) => handleInputChange(e)}
            />

            <ul
              className={`absolute w-full bg-white border rounded-b-lg shadow-lg ${
                props.showWhisper && props.whisperAddress.length > 0
                  ? "block"
                  : "hidden"
              }`}
            >
              {props.whisperAddress.map((item, index) => (
                <li
                  key={index}
                  className="p-2 border-b hover:bg-gray-50 hover:font-medium hover:cursor-pointer"
                  onClick={() => {
                    props.onWhisperSelected(item)
                  }}
                >
                  {item.name},{" "}
                  {
                    item.regionalStructure.find(
                      (i) => i.type == "regional.municipality"
                    )?.name
                  }{" "}
                  {item.zip}
                </li>
              ))}
            </ul>
          </div>

          <input
            type="tel"
            name="phone"
            placeholder="Telefon"
            className="col-span-2 p-2 border rounded-lg"
            value={props.shownData.phone}
            required
            onChange={(e) => handleInputChange(e)}
          />
          <input
            type="email"
            name="email"
            placeholder="E-mail"
            className="col-span-2 p-2 border rounded-lg"
            value={props.shownData.email}
            onChange={(e) => handleInputChange(e)}
            required
          />
        </form>
      </div>
    </div>
  )
}
